import { Stack, Typography } from "@mui/material";
import type { Control } from "react-hook-form";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import { Resources, useResource } from "Translations/Resources";
import type { CampaignFormData } from "./campaignFormSchema";

const RESOURCES = Resources.Admin.Campaigns.Form;

type Props = {
  control: Control<CampaignFormData>;
  isSubmitting: boolean;
  isEditMode: boolean;
  onCodeManuallyEdited: () => void;
  onNameChange: () => void;
};

export const BasicInformationSection = ({
  control,
  isSubmitting,
  isEditMode,
  onCodeManuallyEdited,
  onNameChange,
}: Props) => {
  const { t } = useResource();

  return (
    <Stack gap={3}>
      <Typography variant="h6" fontWeight={600}>
        {t(RESOURCES.BasicInformation)}
      </Typography>
      <FormInput
        control={control}
        name="name"
        label={t(RESOURCES.CampaignName)}
        fullWidth
        disabled={isSubmitting}
        placeholder={t(RESOURCES.CampaignNamePlaceholder)}
        onAfterChange={onNameChange}
      />
      <FormInput
        control={control}
        name="code"
        label={t(RESOURCES.CampaignCode)}
        fullWidth
        disabled={isEditMode || isSubmitting}
        placeholder={t(RESOURCES.CampaignCodePlaceholder)}
        helperText={
          !isEditMode
            ? t(RESOURCES.CampaignCodeHelperCreate)
            : t(RESOURCES.CampaignCodeHelperEdit)
        }
        onBlur={onCodeManuallyEdited}
      />
      {/* Commenting out for now, logic around will likely be changed in near future */}
      {/* <CheckboxInput
        control={control}
        name="isAffiliateEnabled"
        label={t(RESOURCES.EnableAffiliateProgram)}
        disabled={isSubmitting}
      /> */}
    </Stack>
  );
};
